import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { getVcnManagementList } from '../../../api/vcn-management-api-client'
import type { VcnManagementBenefitFilters } from '../types'
import { toVcnManagementBenefitListRequest } from '../filterVcnManagementBenefitRows'

export const VCN_MANAGEMENT_QUERY_KEY = 'vcn-management'

export function useVcnManagementList(
  filters: VcnManagementBenefitFilters,
  page: number,
  pageSize: number
) {
  const request = useMemo(
    () => toVcnManagementBenefitListRequest(filters, page, pageSize),
    [filters, page, pageSize]
  )

  const requestKey = useMemo(() => JSON.stringify(request), [request])

  return useQuery({
    queryKey: [VCN_MANAGEMENT_QUERY_KEY, requestKey],
    queryFn: () => getVcnManagementList(request),
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
